import { render, staticRenderFns } from "./BindWallet.vue?vue&type=template&id=98d62d2e&scoped=true"
import script from "./BindWallet.vue?vue&type=script&lang=js"
export * from "./BindWallet.vue?vue&type=script&lang=js"
import style0 from "./BindWallet.vue?vue&type=style&index=0&id=98d62d2e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d62d2e",
  null
  
)

/* custom blocks */
import block0 from "./BindWallet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports